// extracted by mini-css-extract-plugin
export default {"title":"D_-z","warning":"E_-z","sizeOptionsLegendText":"F_-z"};